import { localStore, sessionStore } from "@auvious/utils";
/* eslint-disable no-fallthrough */
import debug from "debug";
const log = debug("auvious:restorable");
export class Restorable {
    constructor(sessionStoreKeys = [], localStoreKeys = []) {
        this.sessionStoreKeys = sessionStoreKeys;
        this.localStoreKeys = localStoreKeys;
    }
    restoreState(state) {
        Object.keys(state).forEach((key) => {
            if (this.localStoreKeys.includes(key)) {
                localStore.setItem(key, state[key]);
            }
            if (this.sessionStoreKeys.includes(key)) {
                sessionStore.setItem(key, state[key]);
            }
        });
    }
    getRestorableState() {
        const state = {};
        this.localStoreKeys.forEach((key) => (state[key] = localStore.getItem(key)));
        this.sessionStoreKeys.forEach((key) => (state[key] = sessionStore.getItem(key)));
        // clean
        const cleanState = this.removeNullUndefined(state);
        log("State to be restored", cleanState);
        return cleanState;
    }
    removeNullUndefined(obj) {
        // eslint-disable-next-line compat/compat
        return Object.fromEntries(Object.entries(obj).filter(([_, v]) => v != null));
    }
}
